import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#ccc'
const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: 'row',
        borderBottomColor: '#ccc',
        backgroundColor: '#ccc',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 20,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
        fontSize: 12
    },
    description: {
        display: "flex",
        alignItems: 'center',
        width: '60%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    rate: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    amount: {
        width: '15%'
    },
});

const InvoiceTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.description}>Produto</Text>
        <Text style={styles.qty}>Qnt.</Text>
        <Text style={styles.rate}>Valor Unt.</Text>
        <Text style={styles.amount}>Valor Total</Text>
    </View>
);

export default InvoiceTableHeader